import React from "react";
import Header from "../common/Header/Header";
import Footer from "../common/Footer/Footer";
import AllExperts from "../components/ourExpertStaff/AllExperts";
import CustomTestimonialsSlider from "../components/TestimonialSlider";
import SEO from "../components/SEO/SEO";
// import { MotionZoomIn } from "../wrapper/MotionsWrapper";

const ExpertStaffPage = () => {
  return (
    <>
      <SEO
        title="Our Expert Therapists"
        description="Meet our licensed and experienced therapists. Browse profiles, specializations, and languages to find the right mental health professional for you."
        canonical="https://mindtherapycounselling.com/experts"
      />
      <Header />
      {/* <MotionZoomIn> */}
        <AllExperts />
        <CustomTestimonialsSlider />
        <Footer />
      {/* </MotionZoomIn> */}
    </>
  );
};

export default ExpertStaffPage;
